import { Component } from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { analytics } from "@/lib/analytics";

let lastReport = 0;
const report = (kind, message, stack) => {
  if (Date.now() - lastReport < 2000) return; // don't flood analytics on error loops
  lastReport = Date.now();
  try { analytics.track("client_error", { category: "reliability", label: kind, metadata: { message: String(message).slice(0, 300), stack: String(stack || "").slice(0, 1200), url: window.location.pathname } }); } catch { /* ignore */ }
};

if (typeof window !== "undefined" && !window.__tcErrorHooks) {
  window.__tcErrorHooks = true;
  window.addEventListener("error", (e) => report("window.error", e.message, e.error?.stack));
  window.addEventListener("unhandledrejection", (e) => report("unhandledrejection", e.reason?.message || e.reason, e.reason?.stack));
}

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) { return { error }; }

  componentDidCatch(error, info) { report("render", error?.message, info?.componentStack); }

  render() {
    if (!this.state.error) return this.props.children;
    const chunk = /Loading chunk|ChunkLoadError|dynamically imported module/i.test(String(this.state.error?.message));
    return (
      <div className="tc-crash" data-testid="error-boundary">
        <div className="tc-crash__card">
          <AlertTriangle size={28} />
          <h1>{chunk ? "Total Chat was updated" : "Something went wrong"}</h1>
          <p>{chunk ? "A new version was deployed while this tab was open. Reload to pick it up — nothing was lost." : "This part of Total Chat hit an unexpected error. Your messages are safe; reloading usually fixes it."}</p>
          <div className="tc-crash__actions">
            <button className="tc-btn tc-btn--primary" onClick={() => window.location.reload()} data-testid="error-reload"><RefreshCw size={14} /> Reload</button>
            <button className="tc-btn tc-btn--outline" onClick={() => { this.setState({ error: null }); window.location.assign("/client"); }} data-testid="error-home">Back to Total Chat</button>
          </div>
          <details className="tc-crash__details"><summary>Technical details</summary><pre>{String(this.state.error?.stack || this.state.error?.message || this.state.error)}</pre></details>
        </div>
      </div>
    );
  }
}
